//The function in this file is intended to be called by pages IE
//does not support.  It redirects the user to an explanatory page
//if IE is detected and takes code from the following page:
//https://stackoverflow.com/questions/19999388/check-if-user-is-using-ie-with-jquery

export const checkForIE = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");

    if (msie > -1 || ua.match(/Trident.*rv\:11\./)) {
        //IE detected; redirect user
        location.href = "./browser-message.html";
    }
}
